<dialog
  #certificationUsersDialog
  qai-dialog
  (closeButtonClicked)="handleCloseModal()"
>
  <app-certification-users
    [isUserModalOpen]="openUserModal"
    [pageSize]="10"
    [moduleAssignmentUuid]="moduleAssignmentUuid"
    [teamUuids]="teamUuids"
    [certificationStatus]="certificationStatus"
    [userData]="userData"
    [isLoadingData]="isLoadingData"
    (closeUserModal)="handleCloseModal()"
    [assignmentName]="assignmentName"
  ></app-certification-users>
</dialog>
